import { render, staticRenderFns } from "./TemplateMessageDeleteModal.vue?vue&type=template&id=f615dabe&"
import script from "./TemplateMessageDeleteModal.vue?vue&type=script&lang=js&"
export * from "./TemplateMessageDeleteModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports